import { get } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const opportunityPipelineService = {
  /**
   * Get aggregated statistics for the opportunity pipeline dashboard
   * @returns {Promise<Object>} Pipeline statistics data
   */
  getPipelineStats: async () => {
    try {
      const response = await get(`${API_ENDPOINTS.CRM.OPPORTUNITY_PIPELINE}/stats`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve pipeline statistics'
        };
      }
    } catch (error) {

      return {
        success: false,
        error: error.message || 'Failed to retrieve pipeline statistics'
      };
    }
  }
};

export default opportunityPipelineService;